import React, { FC } from 'react';

import { getClassNames } from './StickyTop.styles';
import { StickyTopProps } from './StickyTop.types';

const StickyTop: FC<StickyTopProps> = ({ topOffset = 0, children }) => (
  <div className={getClassNames(topOffset).stickyTop}>{children}</div>
);

export default StickyTop;
